import React from 'react';
import PropTypes from 'prop-types';

import Label from 'ui/text/Label';

import { IconButton, TextField } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

const TicketFormFields = ({ ticket, onChange, showDelete, onDelete }) => {
  return (
    <div className='event-form-ticket'>
      <TextField
        name="title"
        label="Title *"
        value={ticket.title || ''}
        onChange={onChange}
        fullWidth
        size="small"
        color="warning"
        InputProps={{
          endAdornment: showDelete ? (
            <IconButton highlighted onClick={onDelete}>
              <DeleteIcon color='warning'/>
            </IconButton>
          ) : null
        }}
      />

      <TextField
        name="description"
        label="Description"
        value={ticket.description || ''}
        onChange={onChange}
        fullWidth
        size="small"  
        multiline
        rows={3}
        inputProps={{ maxLength: 300 }}
        color="warning"
      />

      <div className='row'>
        <TextField
          name="supply_limit"
          label="Supply Limit"
          value={ticket.supply_limit || ''}
          onChange={onChange}
          fullWidth
          size="small"
          color="warning"
        />
        <TextField
          name="price"
          label="Price"
          value={ticket.price || ''}
          onChange={onChange}
          fullWidth
          size="small"
          color="warning"
        />
        <Label secondary padded>Leave empty for unlimited or free</Label>
      </div>
    </div>
  );
};

TicketFormFields.propTypes = {
  ticket: PropTypes.object,
  onChange: PropTypes.func,
  showDelete: PropTypes.bool,
  onDelete: PropTypes.func
};

export default TicketFormFields;

